
import React, { Component } from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';

import './SettingModal.css';

export default class SettingModal extends Component {
  render() {
    const { field, closeModal, value, valid, submit, value2 } = this.props;
    let status;
    let textColor;
    if (value.length === 0) {
      status = { borderColor: '#aaa' };
      textColor = { color: '#aaa' };
    } else if (value.length > 0 && !valid) {
      status = { borderColor: '#cc0000' };
      textColor = { color: '#cc0000' };
    } else if (value.length > 0 && valid) {
      status = { borderColor: '#00cc00' };
      textColor = { color: '#00cc00' };
    }
    return (
      <div className="mobile-setting-modal d-flex flex-column">
        <div className="mobile-setting-modal__top" onClick={() => closeModal(field.modal)}>
        </div>
        <div className="mobile-setting-modal__bottom">
          <h1 className="mb-4">انتخاب {field.label}</h1>
          <div className="mobile-setting-modal__bottom--field d-flex flex-column mb-4">
            <span style={textColor}>لطفا {field.label} خود را وارد کنید</span>
            <input
              type={field.type}
              name={field.name}
              placeholder={field.placeholder}
              onChange={e => this.props.changeValue(e.target.name, e.target.value, field.type)}
              autoComplete="off"
              value={value}
              style={status}
            />
          </div>
          {
            field.type === 'password' ?
              <div className="mobile-setting-modal__bottom--field d-flex flex-column mb-4">
                <span style={textColor}>تکرار رمز عبور</span>
                <input
                  type={field.type}
                  name={'password2'}
                  placeholder={field.placeholder}
                  onChange={e => this.props.changeValue(e.target.name, e.target.value, field.type)}
                  autoComplete="off"
                  value={value2}
                  style={status}
                />
              </div> : null
          }
          <div className="mobile-setting-modal__bottom--submit d-flex">
            <button className={!valid ? 'btn disabled btn-secondary' : 'btn btn-primary'} onClick={() => { if (valid) { submit() } }}>ثبت</button>
          </div>
        </div>
      </div>
    );
  }
}

